const PREFIX = 'foretour:tripAccess:';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function getTripAccess(code) {
  try {
    const raw = localStorage.getItem(PREFIX + code);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.savedAt && Date.now() - data.savedAt > TTL_MS) {
      localStorage.removeItem(PREFIX + code);
      return null;
    }
    return data;
  } catch { return null; }
}

export function setTripAccess(code, role, password, legacy = false) {
  localStorage.setItem(PREFIX + code, JSON.stringify({ role, password, legacy, savedAt: Date.now() }));
}

export function clearTripAccess(code) {
  localStorage.removeItem(PREFIX + code);
}
